(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.blog-swiper', {
      slidesPerView: 1.128,
      spaceBetween: 12, 
      loop: true, 
      watchSlidesProgress: true,   
      watchOverflow: true, 
      autoplay: {
        delay: 10000,  
        disableOnInteraction: false,  
      },
      breakpoints: {
        1100: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1050: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        868: {
          slidesPerView: 3.2,
        },
        568: {
          slidesPerView: 2.2,
        },
        0: {
          slidesPerView: 1.128,
          spaceBetween: 12
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.features-swiper', {
      slidesPerView: 1.128,
      spaceBetween: 12,
      loop: true, 
      breakpoints: {
        1100: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1050: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        868: {
          slidesPerView: 3.2,
        },
        568: {
          slidesPerView: 2.2,
        },
        0: {
          slidesPerView: 1.128,
          spaceBetween: 12
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
